import React, { useState } from 'react'
import Header from './header'
import { Button } from '@/components/ui/button'
import { Building, Send, ActivityIcon, BarChart2, Boxes, ReceiptTextIcon } from 'lucide-react'
import ReceivedBadge from '@/routes/(inventory)/-module-components/badges/received'
import CustomTabs from '@/components/purchase-order/components/custom_tabs'
import MetricsTab from '@/components/purchase-order/components/metrics_tab'
import StocksTab from '@/components/purchase-order/components/stocks_tab'
import ActivityTab from '@/components/purchase-order/components/activity_tab'
import UpdateStatusDialog from '@/components/purchase-order/components/update-status-dialog'
import { Route as poRoute } from "@/routes/(pharma)/_layout/inventory/purchase-request/$id/index"
import { Level } from '@/gen/auth/common_pb'
import POPDF from '@/components/composable-pdf/po-pdf'
import { pdf } from '@react-pdf/renderer'
import { useRouter } from '@tanstack/react-router'
import { Supplier, SupplierMetadata } from '@/gen/suppliers/common_pb'
const screen = () => {
  const [activeTab, setActiveTab] = useState('Activity')
  const data = poRoute.useLoaderData()
  const params = poRoute.useParams()
  const router = useRouter();
  const TABS = [
      { label: 'Activity', icon: <ActivityIcon className="w-3 h-3" />, count: data.activity.activities.length || 0 },
      { label: 'Metrics', icon: <BarChart2 className="w-3 h-3" /> },
      { label: 'Stocks', count: data.purchaseRequest.purchaseRequest?.items.length, icon: <Boxes className="w-3 h-3" /> },
  ]

  const supplierInfo = new Supplier()

  return (
    <div className="h-screen w-full max-w-screen flex flex-col overflow-hidden">
      <Header />
      <hr className='mt-2' />
      <div className="flex items-center justify-between px-2 py-2">
        <div className="flex items-center gap-x-1">
          <span className="text-sm font-medium">{data.purchaseRequest.purchaseRequest?.requestNumber}</span>
          <span className="h-5 w-px bg-border mx-1" />
          <span className="text-sm text-gray-600 underline">Stock Point: {data.purchaseRequest.purchaseRequest?.stockPointName}</span>
        </div>
      </div>
      <CustomTabs tabs={TABS} activeTab={activeTab} onTabClick={setActiveTab} />
      <hr className='' />
      <div className="flex-1 min-h-0 pb-24">
        {activeTab === 'Activity' && <ActivityTab activities={data.activity.activities} supplierInfo={supplierInfo} initiatedBy={Level.STOCK_POINT} productCount={data.purchaseRequest.purchaseRequest?.items.length!}/>}
        {activeTab === 'Metrics' && <MetricsTab />}
        {activeTab === 'Stocks' && <StocksTab prItems={data.purchaseRequest.purchaseRequest?.items} supplierInfo={supplierInfo}/>}
      </div>
    </div>
  )
}

export default screen